import { Col, Form, Switch } from 'antd'

import './styles.scss'
import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'

export default function BooleanSwitchFormField({ fieldInfo }: TFieldProps) {
  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }

  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`boolean-switch-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        valuePropName='checked'
        rules={setFieldRules()}
      >
        <Switch
          size='small'
          unCheckedChildren={fieldInfo.uncheckedChildrend ?? 'No'}
          checkedChildren={fieldInfo.checkedChildren ?? 'Sí'}
        />
      </Form.Item>
    </Col>
  )
}
